// Contacts (29 Oct 2026, docs/specs/NAVIGATION_2026_10.md): every firm and person the business knows or has contacted,
// and Find (30 Oct 2026, docs/specs/CAMPAIGN_LED_2026_10.md): searching for firms is a CRM job, so known and new firms
// are found in one place. Looking up one company (by name, website or number) and the news and tenders sit beside the search. The import, duplicates
// and the CRM's own settings live in Settings › Data.
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { FlatModule } from "./types";
import { screen } from "./screen";

const Companies = screen(() => import("../screens/Companies"), "Companies");
const Firm = screen(() => import("../screens/Firm"), "Firm");
const People = screen(() => import("../screens/People"), "People");
const Person = screen(() => import("../screens/Person"), "Person");
const ProspectsPage = screen(() => import("../screens/find/Prospects"), "ProspectsPage");
const AddTargetPage = screen(() => import("../screens/find/AddTarget"), "AddTargetPage");
const SignalsPage = screen(() => import("../screens/find/Signals"), "SignalsPage");

export const contacts: FlatModule = {
  key: "contacts",
  label: "Contacts",
  layout: "flat",
  items: [
    { path: "/contacts/companies", label: "Companies", step: "2.W", render: () => <Companies /> },
    { path: "/contacts/people", label: "People", step: "3.10", render: () => <People /> },
    { path: "/contacts/find", label: "Find", step: "2.1", render: () => <ProspectsPage /> },
    { path: "/contacts/find/firm", label: "One company", step: "2.21", render: () => <AddTargetPage /> },
    { path: "/contacts/find/news", label: "News and tenders", step: "2.4", render: () => <SignalsPage /> },
  ],
  extraPages: [
    { path: "/contacts/companies/:id", label: "Company", step: "2.W", render: () => <Firm /> },
    { path: "/contacts/people/:id", label: "Person", step: "3.10", render: () => <Person /> },
  ],
  taskHomes: {
    // 2.9 a tender to bid on or not, beside the news that found it
    review_tender: ["/contacts/find/news"],
  },
};
